import { render, staticRenderFns } from "./StorageListAddNew.vue?vue&type=template&id=20879c76"
import script from "./StorageListAddNew.vue?vue&type=script&lang=js"
export * from "./StorageListAddNew.vue?vue&type=script&lang=js"
import style0 from "./StorageListAddNew.vue?vue&type=style&index=0&id=20879c76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports